import request from '@/utils/request'

// ==================== 验证码 ====================
export function getCaptcha() {
    return request({ url: '/captcha', method: 'get' })
}

// ==================== 登录/登出 ====================
export function login(data) {
    return request({ url: '/login', method: 'post', data })
}

export function logout() {
    return request({ url: '/logout', method: 'post' })
}

// ==================== 用户管理 ====================
export function getUserList(params) {
    return request({ url: '/user/list', method: 'get', params })
}

export function addUser(data) {
    return request({ url: '/user/add', method: 'post', data })
}

export function updateUser(data) {
    return request({ url: '/user/update', method: 'put', data })
}

export function deleteUser(id) {
    return request({ url: `/user/delete/${id}`, method: 'delete' })
}

export function batchDeleteUser(ids) {
    return request({ url: '/user/batchDelete', method: 'delete', data: ids })
}

export function resetUserPassword(id) {
    return request({ url: `/user/resetPwd/${id}`, method: 'put' })
}

export function changeStatus(id, status) {
    return request({ url: `/user/changeStatus`, method: 'put', params: { userId: id, status } })
}

export function getUserInfo() {
    return request({ url: '/user/info', method: 'get' })
}

// ==================== 唯一性检查 ====================
export function checkPhone(userName) {
    return request({ url: '/user/checkPhone', method: 'get', params: { userName } })
}

export function checkEmail(email) {
    return request({ url: '/user/checkEmail', method: 'get', params: { email } })
}

// ==================== 个人中心 ====================
export function getProfile() {
    return request({ url: '/user/profile/info', method: 'get' })
}

export function updateProfile(data) {
    return request({ url: '/user/profile/update', method: 'put', data })
}

export function changePassword(data) {
    return request({ url: '/user/profile/changePassword', method: 'post', data })
}

export function forgotPassword(data) {
    return request({ url: '/forgot', method: 'post', data })
}

export function resetForgotPassword(data) {
    return request({ url: '/reset', method: 'post', data })
}

export function getUsersByDeptId(deptId) {
    return request({ url: '/user/listByDept', method: 'get', params: { deptId } })
}

// ==================== 根据公司获取用户 ====================
export function getUsersByCompanyId(companyId) {
    return request({ url: '/user/listByCompany', method: 'get', params: { companyId } })
}

// ==================== 获取所有用户（用于下拉选择，不依赖公司） ====================
export function listAllUsers() {
    return request({ url: '/user/listAll', method: 'get' })
}

// ==================== 头像上传 ====================
export function uploadAvatar(data) {
    return request({
        url: '/user/profile/uploadAvatar',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 获取部门可添加的员工列表
export function getAvailableUsersForDept(deptId) {
    return request({ url: `/user/availableForDept?deptId=${deptId}`, method: 'get' })
}